export const CITY_MAX_LENGTH = 20;
export const CITY_MIN_LENGTH = 2;

export const CITY_REGEXP =
  // eslint-disable-next-line no-misleading-character-class
  /^[\p{L} \-\u02B9\u0027\u02BC\u02C8\u0301\u030D\u05F3\u2018\u2019\u2032\uA78C]*$/mu;

export const validationCityRules = {
  pattern: {
    value: CITY_REGEXP,
    message: 'validation.wrongSymbols'
  },
  maxLength: {
    value: CITY_MAX_LENGTH,
    message: 'validation.valueLongerThan20'
  },
  minLength: {
    value: CITY_MIN_LENGTH,
    message: 'validation.valueShorterThan2'
  }
};
